export default __webpack_public_path__ + "static/media/acms-me.135d1e6e.svg";